import { render } from "./fullProcessTesting.vue?vue&type=template&id=433b1172&scoped=true"
import script from "./fullProcessTesting.vue?vue&type=script&lang=js"
export * from "./fullProcessTesting.vue?vue&type=script&lang=js"

import "./fullProcessTesting.vue?vue&type=style&index=0&id=433b1172&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-433b1172"]])

export default __exports__